export const settingsQueryKeys = {
  configuration: ['settings', 'configuration'] as const,
  settings: ['settings'] as const,
  mailingAddressFormat: (countryCode: string) =>
    ['settings', 'mailing-address-formats', countryCode] as const,
  preferenceGroups: ['settings', 'preference-groups'] as const,
  preferenceGroupDetails: ['settings', 'preference-groups', 'details'] as const,
  preferenceGroup: (preferenceGroupId: string) =>
    ['settings', 'preference-groups', preferenceGroupId] as const,
  preferenceDefaults: ['settings', 'preference-defaults'] as const,
  userPreferences: ['settings', 'user-preferences'] as const,
}
